import React from 'react';
import {
    MenuItem, Menu, createStyles, Theme,
    makeStyles, withStyles, WithStyles, DialogTitle as MuiDialogTitle,
    Typography, IconButton
} from '@material-ui/core';
import Paper, { PaperProps } from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import Draggable from 'react-draggable';

export const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        padding: '0px'
    },
})((props: any) => (
    <Menu
        transitionDuration={0}
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

export const StyledMenuItem = withStyles(theme => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
                padding: "1px"
            },
        },
    },
}))(MenuItem);

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
}

export const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} style={{ cursor: 'move' }} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon style={{ color: '#597dda' }} />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 0px 0px 0px'
        },
        root: {
            color: '#597DDA',
            marginLeft: '15px',
            fontSize: '1rem',
        },
        dialogTitle: {
            color: '#597DDA',
            marginLeft: '6px',
            fontSize: '1rem',
        },
        rootContent: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.paper,
            borderRadius: '3px',
            margin: '10px'
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        footForm: {
            textAlign: 'right'
        },
        rootButton: {
            marginLeft: '10px',
        },
        rootCancelButton: {
            marginLeft: '10px'
        },
        tableHeadCenter: {
            '& > span': {
                justifyContent: 'center'
            }
        },
    })
);
